import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "../Button/Button";
import "./ModerRejectReason.scss";
import ReasonListModal from "../ReasonListModal/ReasonListModal";

const ModerRejectReason = ({ reasons, selectedReasons, onChange }) => {
  const [show, setShow] = useState(false);

  const showModal = () => setShow(true);
  const hideModal = () => setShow(false);
  const reset = () => onChange({ reasons: [] });

  const onConfirm = e => {
    onChange(e);
    hideModal();
  };

  return (
    <div className="mr-selector">
      {show && (
        <ReasonListModal
          onCancel={hideModal}
          items={reasons}
          selected={selectedReasons}
          onConfirm={onConfirm}
        />
      )}

      {selectedReasons.length == 0 ? (
        <Button color="red" onClick={showModal}>
          Выбрать причину
        </Button>
      ) : (
        <Button
          color="blue"
          className="mr-selector__change"
          onClick={showModal}
        >
          Изменить причину
        </Button>
      )}
    </div>
  );
};

ModerRejectReason.propTypes = {
  reasons: PropTypes.array.isRequired,
  selectedReasons: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

ModerRejectReason.defaultProps = {
  reasons: [],
  selectedReasons: []
};

export default ModerRejectReason;
